import { apiSlice } from "../../apiSlice";

export interface ReportUser {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  createdAt?: string | null; // Date
  lastAppUse?: string | null; // Date
  profileName?: string | null;
  branchOfService?: string | null;
  athleteStatus?: string | null;
  primaryTest?: string | null;
  gender?: string | null;
  height?: string | null; // String?
  weight?: string | null; // String?
  bmi?: string | null; // String?
  neckCircumference?: string | null;
  abdomenCircumference?: string | null;
  hipCircumference?: string | null;
  waistCircumference?: string | null;
  bodyFatPercentage?: string | null;
  address?: {
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
  } | null;
  timezone?: string | null;
  organizationId?: string | null;
  subscriptionLevel?: string | null;
  pricePaid?: string | null;
  subscriptionStartDate?: string | null;
  subscriptionEndDate?: string | null;
  totalWorkoutsCompleted?: number | null;
  activeTrainingPlanId?: string | null;
  lastTestId?: string | null;
  organization?: {
    name?: string | null;
    memberCount?: string | null;
  } | null;
  lastTest?: {
    title?: string | null;
    date?: string | null; // Date
    type?: string | null;
    score?: string | null;
    status?: string | null;
    level?: string | null;
    exercises?:
      | {
          name?: string | null;
          rawScore?: string | null;
          calculatedScore?: string | null;
        }[]
      | null;
  } | null;
  trainingPlan?: {
    name?: string | null;
    questionnaire?: any | null;
    workoutsCompleted?: number | null;
    workoutsRemaining?: number | null;
    coach?: {
      firstName?: string | null;
      lastName?: string | null;
    } | null;
    workouts?: {
      name?: string | null;
      status?: string | null;
      date?: string | null; // Date
    }[];
  } | null;
  lastWorkout?: {
    name?: string | null;
    status?: string | null;
    date?: string | null; // Date
  } | null;
}

export const reportingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsersReport: builder.mutation({
      query: (payload) => ({
        url: "/api/reporting/users-report",
        method: "POST",
        body: payload,
      }),
      transformResponse: (response: { data: { users: any; total: number } }) =>
        response.data,
    }),
    exportUsersReport: builder.mutation({
      query: (payload) => ({
        url: "/api/reporting/export-users-report",
        method: "POST",
        body: payload,
      }),
      transformResponse: (response: { data: { url: string } }) =>
        response.data.url,
    }),
  }),
});

export const { useGetUsersReportMutation, useExportUsersReportMutation } =
  reportingApiSlice;
